// Cổng vào sau đăng nhập Google: kiểm whitelist app_user (tái dùng pilot P0) rồi mở vỏ app.
// Thay DashboardScreen của pilot.
import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { layAppUserHienTai } from "../api/appUser";
import { dangXuat } from "../api/auth";
import { doThoiGian, ghiDiemDo } from "../core/perf";
import { VoApp } from "./VoApp";

export function CongVao({ userId }: { userId: string }) {
  const { data: kq, isLoading } = useQuery({
    // Gắn userId vào khoá để cache của người trước không bao giờ hiện cho người sau.
    queryKey: ["app_user_hien_tai", userId],
    queryFn: () => doThoiGian("khoi_dong", "tai_app_user", () => layAppUserHienTai(userId)),
  });
  const dungDuoc = kq?.ok === true && kq.data !== null;

  useEffect(() => {
    if (!dungDuoc) return;
    // Mốc "dùng được": tính từ lúc mở trang (cùng định nghĩa Tổng của DO_THOI_GIAN bên GAS). Chỉ ghi RAM — gửi lên bảng
    // do_thoi_gian ở VoApp, CHỈ khi Admin bật "Đo thời gian" (0348: mặc định tắt).
    ghiDiemDo({ man_hinh: "khoi_dong", buoc: "tong_toi_luc_dung_duoc", ms: performance.now() });
  }, [dungDuoc]);

  if (isLoading) return <div className="cong"><p className="muted">Đang tải…</p></div>;

  if (!kq?.ok) {
    return (
      <div className="cong">
        <div className="cong-the">
          <h1>Không tải được tài khoản</h1>
          <p className="red">{kq?.error ?? "Lỗi không rõ"}</p>
          <button type="button" className="btn" onClick={() => window.location.reload()}>Thử lại</button>
          <button type="button" className="btn ghost" onClick={() => void dangXuat()}>Đăng xuất</button>
        </div>
      </div>
    );
  }

  if (!kq.data) {
    return (
      <div className="cong">
        <div className="cong-the">
          <span className="brand-mark" aria-hidden>KH</span>
          <h1>Tài khoản chưa được cấp quyền</h1>
          <p>Đăng nhập Google thành công, nhưng email này chưa có trong danh sách được dùng web vận hành. Nhắn Le để được thêm.</p>
          <button type="button" className="btn" onClick={() => void dangXuat()}>Đăng xuất</button>
        </div>
      </div>
    );
  }

  return <VoApp appUser={kq.data} userId={userId} />;
}
